import React from 'react';
import { Users } from 'lucide-react';
import { Table } from '../types';

interface TableMapProps {
  tables: Table[];
  onTableClick: (table: Table) => void;
  onTableDrag?: (tableId: string, position: { x: number; y: number }) => void;
  editMode?: boolean;
}

export const TableMap: React.FC<TableMapProps> = ({
  tables,
  onTableClick,
  onTableDrag,
  editMode = false
}) => {
  const getTableStatusStyle = (status: Table['status']) => {
    switch (status) {
      case 'libre':
        return 'bg-green-100 border-green-300 text-green-800';
      case 'ocupada':
        return 'bg-red-100 border-red-300 text-red-800';
      case 'reservada':
        return 'bg-yellow-100 border-yellow-300 text-yellow-800';
      case 'limpieza':
        return 'bg-blue-100 border-blue-300 text-blue-800';
      default:
        return 'bg-gray-100 border-gray-300 text-gray-800';
    }
  };

  const getTableShape = (shape: Table['shape']) => {
    switch (shape) {
      case 'round':
        return 'rounded-full';
      case 'rectangle':
        return 'rounded-lg aspect-[3/2]';
      default:
        return 'rounded-lg aspect-square';
    }
  };

  return (
    <div className="relative w-full h-96 bg-gray-50 rounded-lg overflow-hidden">
      {tables.map((table) => (
        <div
          key={table.id}
          data-testid={`table-${table.id}`}
          className={`
            absolute cursor-pointer border-2 flex flex-col items-center justify-center
            w-16 h-16 transition-all hover:shadow-lg
            ${getTableStatusStyle(table.status)}
            ${getTableShape(table.shape)}
          `}
          style={{
            left: `${table.position.x}px`,
            top: `${table.position.y}px`
          }}
          draggable={editMode}
          onClick={() => onTableClick(table)}
        >
          <span className="text-sm font-bold">{table.number}</span>
          <span className="text-xs">{table.capacity}p</span>
          
          {table.status === 'ocupada' && (
            <div
              data-testid="occupied-indicator"
              className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full flex items-center justify-center"
            >
              <Users className="w-2 h-2 text-white" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};